module.exports = __webpack_public_path__ + "img/dalou_3_1@2x.2eabff38.png";